interface CountBadgeProps {
  children: React.ReactNode;
}

export const CountBadge = ({ children }: CountBadgeProps) => (
  <span className="text-xxs bg-brand absolute right-[-12px] top-[-6px] block rounded-full border-2 border-white px-[6px] py-[4px] text-center font-bold leading-none text-white">
    {children}
  </span>
);
